import { DTOError } from 'src/error/errors/DTOError';

import type { PrebuildOrderSuccessPayload } from './types';

import { couponDTO } from './couponDTO';
import { discountMethodsDTO } from './discountMethodsDTO';
import { orderExtrasDTO } from './orderExtrasDTO';
import { packageDTO } from '../package/packageDTO';
import { priceInfoOrDefaultDTO } from './priceInfoOrDefaultDTO';
import { bonusesOrDefaultDTO } from './bonusesOrDefaultDTO';

export const prebuildOrderDTO = (
  data: unknown,
): PrebuildOrderSuccessPayload => {
  if (
    !data ||
    typeof data !== 'object' ||
    !('order' in data) ||
    !data.order ||
    typeof data.order !== 'object'
  ) {
    throw new DTOError('prebuildOrderDTO', data);
  }

  const prebuiltOrderData = data.order;
  if (
    !('full_price' in prebuiltOrderData) ||
    typeof prebuiltOrderData.full_price !== 'number' ||
    !('bonuses' in prebuiltOrderData) ||
    typeof prebuiltOrderData.bonuses !== 'object' ||
    !('coupon' in prebuiltOrderData) ||
    typeof prebuiltOrderData.coupon !== 'object' ||
    !('discount_methods' in prebuiltOrderData) ||
    !Array.isArray(prebuiltOrderData.discount_methods) ||
    !('discount_price' in prebuiltOrderData) ||
    typeof prebuiltOrderData.discount_price !== 'number' ||
    !('order_extras' in prebuiltOrderData) ||
    !Array.isArray(prebuiltOrderData.order_extras) ||
    !('insurance_price' in prebuiltOrderData) ||
    typeof prebuiltOrderData.insurance_price !== 'number' ||
    !('package' in prebuiltOrderData) ||
    typeof prebuiltOrderData.package !== 'object'
  ) {
    throw new DTOError('prebuildOrderDTO', data);
  }

  return {
    priceInfo: priceInfoOrDefaultDTO(
      'price_info' in prebuiltOrderData ? prebuiltOrderData.price_info : null,
    ),
    fullPrice: prebuiltOrderData.full_price,
    bonuses: bonusesOrDefaultDTO(prebuiltOrderData.bonuses),
    coupon: couponDTO(prebuiltOrderData.coupon),
    discount_methods: discountMethodsDTO(prebuiltOrderData.discount_methods),
    discount_price: prebuiltOrderData.discount_price,
    discount_type:
      'discount_type' in prebuiltOrderData &&
      typeof prebuiltOrderData.discount_type === 'string'
        ? prebuiltOrderData.discount_type
        : null,
    order_extras: orderExtrasDTO(prebuiltOrderData.order_extras),
    insurance_price: prebuiltOrderData.insurance_price,
    package: packageDTO(prebuiltOrderData.package),
  };
};
